import React, { useEffect, useRef, useState } from "react";
import "./RefundPayment.css";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { Toast } from "primereact/toast";
import { api } from "../../../../../../../../../../../utility/AxiosInceptor";
import CommonLoaderBlue from "../../../../../../../../../../components/Loader/LoaderBlue";
export const RefundPayment = ({
  setRefershPaymentLogs,
  cpData,
  currentRowData,
  setIsRefundDialogActive,
}) => {
  let toast = useRef();
  const LoginRes = JSON.parse(localStorage.getItem("userData"));
  const [isLoading, setIsLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      paymentIntentId: currentRowData?.transactionId,
      customerId: cpData?._id,
      userId: LoginRes?._id,
      amount: currentRowData?.amount,
    },
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      api
        .post(`/api/web/billing/refund`, values)
        .then((res) => {
          toast.current.show({
            severity: "success",
            summary: "Refund Payment",
            detail: res?.data?.msg || "Payment has been successfully refunded",
          });
          setIsRefundDialogActive(false);
          setRefershPaymentLogs((prev) => !prev);
        })
        .catch((err) => {
          toast.current.show({
            severity: "error",
            summary: "Refund Payment",
            detail:
              err?.response?.data?.msg || "Payment refunding has been failed",
          });
        });
    },
  });
  useEffect(() => {
    const element = document.getElementById("invoice-download-main");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, []);
  return (
    <>
      <div
        style={{
          position: "fixed",
          zIndex: 9999,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#FFFFFF99",
          top: 0,
          left: 0,
        }}
      ></div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit();
        }}
        id="invoice-download-main"
        className="invoice-download-main flex flex-wrap flex-row justify-content-center"
      >
        <div className="main-download-invoice">
          <div className="top-header-downloadinvoice">
            <h1>Refund Payment Confirmation</h1>
            <p>
              Do you want to refund the payment of ${currentRowData.amount} for
              Transaction ID {currentRowData.transactionId}?
            </p>
          </div>
          <div className="action-buttons flex flex-wrap flex-row justify-content-between aligbn-item-center">
            <Button
              disabled={isLoading}
              type="button"
              onClick={() => {
                setIsRefundDialogActive(false);
              }}
              label="Cancel"
            />
            <Button
              type="Submit"
              label={
                isLoading ? (
                  <div className="flex flex-wrap flex-row justify-content-center align-items-center">
                    <CommonLoaderBlue sizehere="12" color="white" />{" "}
                  </div>
                ) : (
                  "Confirm Refund"
                )
              }
            />
          </div>
        </div>
        <Toast ref={toast} />
      </form>
    </>
  );
};
